import _ from 'lodash'

// ==== action types ====

export const EDIT_REGULAR_TOP_UP = 'INVESTMENT/EDIT_REGULAR_TOP_UP'

export const EDIT_REGULAR_PREMIUM = 'INVESTMENT/EDIT_REGULAR_PREMIUM'

export const EDIT_REGULAR_PREMIUM_RATIO = 'INVESTMENT/EDIT_REGULAR_PREMIUM_RATIO'

export const UPDATE_REGULAR_PREMIUM = 'INVESTMENT/UPDATE_REGULAR_PREMIUM'

export const UPDATE_SUM_ASSURED = 'INVESTMENT/UPDATE_SUM_ASSURED'

export const UPDATE_REGULAR_TOP_UP = 'INVESTMENT/UPDATE_REGULAR_TOP_UP'

export const SELECT_MODEL_FACTOR = 'INVESTMENT/SELECT_MODEL_FACTOR'

export const PATCH_MODEL_FACTOR = 'INVESTMENT/PATCH_MODEL_FACTOR'

export const PREVIOUS_MODEL_FACTOR = 'INVESTMENT/PREVIOUS_MODEL_FACTOR'

export const EDIT_SUM_ASSURED = 'INVESTMENT/EDIT_SUM_ASSURED'

export const EDIT_LUMP_SUM = 'INVESTMENT/EDIT_LUMP_SUM'

export const UPDATE_LUMP_SUMS = 'INVESTMENT/UPDATE_LUMP_SUMS'

export const UPDATE_EXPECTED_RETURN_COMPARISONS = 'INVESTMENT/UPDATE_EXPECTED_RETURN_COMPARISONS'

export const UPDATE_RPUDR_EXPECTED_RETURN_COMPARISONS = 'INVESTMENT/UPDATE_RPUDR_EXPECTED_RETURN_COMPARISONS'

export const RESET_EXPECTED_RETURN_COMPARISONS = 'INVESTMENT/RESET_EXPECTED_RETURN_COMPARISONS'

export const RESET_RPUDR_EXPECTED_RETURN_COMPARISONS = 'INVESTMENT/RESET_RPUDR_EXPECTED_RETURN_COMPARISONS'

// ==== action creators ====
export const editSumAssured = (sumAssured) => ({
  type: EDIT_SUM_ASSURED,
  payload: _.toFinite(sumAssured),
})

export const editRegularTopUp = (regularTopUp) => ({
  type: EDIT_REGULAR_TOP_UP,
  payload: _.toFinite(regularTopUp),
})

export const editRegularPremium = (regularPremium) => ({
  type: EDIT_REGULAR_PREMIUM,
  payload: _.toFinite(regularPremium),
})

export const editRegularPremiumRatio = (regularPremiumRatio) => ({
  type: EDIT_REGULAR_PREMIUM_RATIO,
  payload: _.toFinite(regularPremiumRatio),
})

export const updateSumAssured = (sumAssured, errors) => ({
  type: UPDATE_SUM_ASSURED,
  payload: { value: sumAssured, errors },
})

export const updateRegularPremium = (regularPremium, errors) => ({
  type: UPDATE_REGULAR_PREMIUM,
  payload: { value: regularPremium, errors },
})

export const updateRegularTopUp = (regularTopUp, errors) => ({
  type: UPDATE_REGULAR_TOP_UP,
  payload: { value: regularTopUp, errors },
})

export const selectModelFactor = (modelFactorID) => ({
  type: SELECT_MODEL_FACTOR,
  payload: modelFactorID,
})

export const patchModelFactor = (modelFactorID) => ({
  type: PATCH_MODEL_FACTOR,
  payload: modelFactorID,
})

export const previousModelFactor = (modelFactorID) => ({
  type: PREVIOUS_MODEL_FACTOR,
  payload: modelFactorID,
})

export const editLumpSum = (lumpSum) => ({
  type: EDIT_LUMP_SUM,
  payload: lumpSum,
})

export const updateLumpSums = (lumpSumValidationResult) => ({
  type: UPDATE_LUMP_SUMS,
  payload: lumpSumValidationResult,
})

export const updateExpectedReturnComparisons = (expectedReturnComparisons) => ({
  type: UPDATE_EXPECTED_RETURN_COMPARISONS,
  payload: expectedReturnComparisons,
})

export const updateRPUDRExpectedReturnComparisons = (expectedReturnComparisons) => ({
  type: UPDATE_RPUDR_EXPECTED_RETURN_COMPARISONS,
  payload: expectedReturnComparisons,
})

export const resetExpectedReturnComparisons = () => ({
  type: RESET_EXPECTED_RETURN_COMPARISONS,
})

export const resetRPUDRExpectedReturnComparisons = () => ({
  type: RESET_RPUDR_EXPECTED_RETURN_COMPARISONS,
})
